// extracted by mini-css-extract-plugin
export default {"icon":"style-module__LwoZl","video":"style-module__oc3_k","videoContainer":"style-module__TfiXG"};